import styled from 'styled-components';

export const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const AlertBox = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
  border-top: 4px solid ${props => 
    props.type === 'success' ? '#4CAF50' :
    props.type === 'error' ? '#f44336' :
    props.type === 'warning' ? '#FF9800' :
    '#667eea'
  };

  @keyframes slideIn {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const AlertHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
`;

export const AlertLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
`;

export const AlertTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
`;

export const AlertMessage = styled.p`
  margin: 0 0 20px 0;
  font-size: 15px;
  line-height: 1.6;
  color: #555;
  text-align: center;
`;

export const AlertButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background: ${props => 
    props.type === 'success' ? 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)' :
    props.type === 'error' ? 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)' :
    props.type === 'warning' ? 'linear-gradient(135deg, #FF9800 0%, #f57c00 100%)' :
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  };
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;
